export default __webpack_public_path__ + "static/media/paypal.67d01a06.svg";